
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/is-policy",
      function () {
        return require("private-next-pages/is-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/is-policy"])
      });
    }
  